import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { getCarsByCardAddVin } from "@/api/ykTerminalManage/carService";
export default {
  name: "YKCarNumberSelect",
  props: {
    carNumber: {
      type: String,
      default: ""
    },
    queryType: {
      type: Number,
      default: function _default() {
        return 1;
      }
    },
    label: {
      type: String,
      default: "carNumber"
    },
    value: {
      type: String,
      default: "carNumber"
    },
    searchLenth: {
      type: Number,
      default: function _default() {
        return 1;
      }
    }
  },
  data: function data() {
    return {
      cardList: [],
      loading: false,
      getCarsByCardAddVin: new Function()
    };
  },
  computed: {
    carNumberSelect: {
      get: function get() {
        return this.carNumber;
      },
      set: function set(val) {
        this.$emit("update:carNumber", val);
      }
    }
  },
  methods: {
    //获取车牌号下拉列表
    getCarsByCardAddVin: function (_getCarsByCardAddVin) {
      function getCarsByCardAddVin(_x) {
        return _getCarsByCardAddVin.apply(this, arguments);
      }
      getCarsByCardAddVin.toString = function () {
        return _getCarsByCardAddVin.toString();
      };
      return getCarsByCardAddVin;
    }(function (str) {
      var _this = this;
      if (str === "" || str == null) return;
      getCarsByCardAddVin({
        carNumber: str,
        queryType: this.queryType
      }).then(function (res) {
        if (res.code === 200) {
          _this.cardList = res.data || [];
        }
      });
    }),
    //远程获取车牌号列表
    cardsAndVinSerch: function cardsAndVinSerch(query) {
      this.getCarsByCardAddVin(query);
    }
  }
};